import { IField, IFieldElem } from '@models/IFormData';

type FieldMap = Record<string, IFieldElem>;

export const applyEditFormFieldsToRowData = (
    data: IField[],
    rowData: Record<string, any>,
    fields: FieldMap,
    setParentField: (field: IField) => void,
    rowFieldKeys?: ReadonlySet<string>,
    sourceTableKey?: string,
) => {
    for (let index = 0; index < data.length; index++) {
        const field = data[index];

        if (sourceTableKey && (field.name === sourceTableKey || field.name.startsWith('|Parent|'))) {
            if (fields[field.name]) setParentField(field);
            continue;
        }

        if (rowFieldKeys?.has(field.name)) {
            rowData[field.name] = field.value;
            continue;
        }

        if (field.name.startsWith('#links|')) {
            continue;
        }

        if (field.name.includes('|Document')) {
            if (fields[field.name]) {
                setParentField(field);
            }
            continue;
        }

        if (fields[field.name]) {
            continue;
        }

        rowData[field.name] = field.value;
    }
};
